import { useState, type FormEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { usePortalApi } from "../api/ApiContext";
import { useAuth } from "../auth/AuthContext";
import { InlineError, Panel } from "../components/ui";

export function ActivationPage() {
  const [params] = useSearchParams();
  const auth = useAuth();
  const api = usePortalApi();
  const [error, setError] = useState<Error | null>(null);
  const [busy, setBusy] = useState(false);
  const inviteToken = params.get("invite") || "";

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const pin = String(new FormData(event.currentTarget).get("pin") || "");
    setBusy(true);
    setError(null);
    try {
      await api.redeemOwnerInvitation(inviteToken, pin);
      window.location.assign("/");
    } catch (cause) {
      setError(cause instanceof Error ? cause : new Error("Não foi possível ativar o acesso."));
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <Panel title="Ativar acesso ao Portal AVA">
        {!inviteToken && <p>O link de ativação está incompleto ou inválido.</p>}
        {inviteToken && auth.status !== "signed_in" && (
          <>
            <p>Entre com o mesmo e-mail que recebeu o convite para continuar.</p>
            <button type="button" onClick={auth.signIn}>Entrar para ativar</button>
            {auth.error && <p className="error" role="alert">{auth.error}</p>}
          </>
        )}
        {inviteToken && auth.status === "signed_in" && (
          <form onSubmit={submit} className="form-grid">
            <label>
              PIN do convite
              <input name="pin" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} required />
            </label>
            <div className="form-actions">
              <button type="submit" disabled={busy}>
                {busy ? "Ativando…" : "Ativar acesso"}
              </button>
            </div>
          </form>
        )}
        <InlineError error={error} />
      </Panel>
    </main>
  );
}
